import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  RMdetails,
  TAllApplicationsDataArray,
  TAllApplicationsObj,
  TAllLoansData,
  TApplicationViewDetails,
  TBeneficiaryDetails,
  TBillsInfo,
  TBillView,
  TCloseLoanFormData,
  TDisbRecordPayoutData,
  TLoanApproverData,
  TLoanFiltersData,
  TLoanMetricsObj,
  TLoanTabDetailsById,
  TPdfSettings,
  TSmartBoard,
} from "../types";
import moment from "moment";
import {
  TAllBorrowers,
  TLoanApplicationById,
  TLoanClickAppInfo,
  TLoanPartnerDetails,
  TLoanTradeAppInfo,
  TLoanWorkingCapInfo,
  TRecordDisbPayment,
  TRepayHistoryDetails,
} from "../types/loans/loans";
import { TCalendarType } from "../components/commons/ono-calendar-v2/calendar_types";
import { AllPartners } from "../types/loans/partners/partners";

const savedFiltersStr = localStorage.getItem("loanFilters");
const savedFilters = savedFiltersStr ? JSON.parse(savedFiltersStr) : null;

const loanTabFilterStr = localStorage.getItem("loansTabFilters");
const savedLoanTabFilters = loanTabFilterStr
  ? JSON.parse(loanTabFilterStr)
  : null;

export type DateRange = {
  fromDate: string;
  toDate: string;
  mode?: TCalendarType;
};

export type LoanRecordPmt = {
  pmtDate: string;
  amountPaid: string;
  pmtMode: string;
  comments: string;
  images: TLoanDocument[];
};

export type TLoanPmtTableEdit = {
  pmtId: number;
  emiId: number;
  amount: string;
  principalAmt: string;
  interestAmt: string;
  lateFee: number;
  penalties: number;
  waive: number;
  cfInterest: number;
  excessAmt: number;
};

export type TLoanDocument = {
  id: number;
  reqId: number;
  tradeId: number;
  imgFrom: string;
  url: string;
  type: "pmtDoc";
  status: number;
  docType: "image" | "pdf";
  typeId: number;
};

export type TLoanPmtEdit = {
  pmtDate: string;
  amountPaid: number;
  receiptDate: string;
  utr: string;
  waiveOff: number;
  comments: string;
  pmtDocument: TLoanDocument[];
  excessAmt: number;
};
export type TFinancePartnersData = {
  id: number;
  finPartnerName: string;
  finShortName: string;
  approvedLimit: number;
  avlLimit: number;
  disburse: boolean;
};

export type TPartnerRecordPmt = {
  disbDate: string;
  disbAmt: string;
  disbBy: string;
  email: string;
  contactNum: string;
  utr: string;
  pmtMode: string;
  comments: string;
  disbImage: Array<{ docType: "image" | "pdf"; url: string; type: string }>;
};
type TinitialState = {
  applicationViewDetails: TApplicationViewDetails | null;
  pdfSettings: TPdfSettings[];
  billsView: TBillView | null;
  billsInfo: TBillsInfo | null;
  beneficiaryDetails: TBeneficiaryDetails | null;
  appliViewById: TApplicationViewDetails | null;
  reviewedComment: string;
  verifyComment: string;
  approveComment: string;
  disburseComment: string;
  rejectComment: string;
  revalidateRemarks: string;
  payoutCurrentStep: number;
  disRecordPayoutData: TDisbRecordPayoutData;
  loanModalSuccessStatus: boolean;
  // new revamp
  loansSmartBoard: TSmartBoard | null;
  activeLoanTypeTab: string;
  loanSmartboardCollapse: boolean;
  openLoanDetails: boolean;
  currentStep: number;
  activeLoanTab: string;
  activeDisbursePaymentTab: string;
  activeStep: number;
  loanApplicationById: TLoanApplicationById | null;
  loanPartnerDetails: TLoanPartnerDetails | null;
  loanApplicationId: number;
  loanApproverData: TLoanApproverData;
  closeLoanFormData: TCloseLoanFormData;
  refreshAppDetails: boolean;
  rmDetailsArray: RMdetails[];
  getRmDeatilsStatus: boolean;
  allLoanApplicationsData: TAllApplicationsObj | null;
  billsArray: TBillsInfo[];
  disbursementModalOpen: boolean;
  loanClickAppInfo: TLoanClickAppInfo | null;
  loanTradeAppInfo: TLoanTradeAppInfo | null;
  loanWorkingCapitalInfo: TLoanWorkingCapInfo | null;
  loanProductName: string;
  openLoansFilter: boolean;
  openLoansTabFilters: boolean;
  loanFilters: {
    borrowers: TLoanFiltersData[];
    markets: TLoanFiltersData[];
    rms: TLoanFiltersData[];
    status: string[];
    filterMode: "All" | "";
    firstTimeApplied: "FirstTimeApplied" | "";
    loanType: string[];
  };
  loansTabFilters: {
    borrowers: TLoanFiltersData[];
    rms: TLoanFiltersData[];
    status: string[];
    filterMode: "All" | "";
    loanType: string[];
    pendingPmt: string[];
    finPartnerId: TLoanFiltersData[];
  };
  recordDisbursalData: TRecordDisbPayment | null;
  allBorrowersData: TAllBorrowers[];
  openLoanTabDeatilsPanel: boolean;
  loandId: string;
  openCloseLoanPanel: boolean;
  allLoansData: TAllLoansData[];
  loanTabDetailsById: TLoanTabDetailsById | null;
  errorLoan: string;
  errorLoanAppli: string;
  openRepaymentTranscView: boolean;
  filteredLoans: TAllLoansData[];
  refreshLoansAppl: boolean;
  filteredLoanApplications: TAllApplicationsDataArray[];
  dateRange: DateRange;
  repayHistoryId: number;
  pmtStatus: string;
  repayHistoryData: TRepayHistoryDetails | null;
  loanByIdRefresh: boolean;
  laonDateRange: DateRange;
  isEditLoanPmt: boolean;
  loanPmtEdit: TLoanPmtEdit;
  isCancelLoanPmt: boolean;
  rejectComments: string;
  pmtRows: TLoanPmtTableEdit[];
  loanUseEffectStop: boolean;
  applicationSearchTxt: string;
  loanMetrics: TLoanMetricsObj | null;
  isRecordPmt: boolean;
  recordPayment: LoanRecordPmt | null;
  financePartnersData: TFinancePartnersData[];
  lastPaymentStatus: string;
  lastPaymentId: number;
  tenureDays: string[];
  openRejectModal: boolean;
  partnerFinManagerdisbModalOpen: boolean;
  partnerApprovalData: {
    approvalAmout: string;
    comments: string;
    commentsError?: boolean;
  };
  partnerRecordPmt: TPartnerRecordPmt;
  cashId: number;
  allPartners: AllPartners[];
};
const initialState: TinitialState = {
  loanApplicationById: null,
  applicationViewDetails: null,
  pdfSettings: [],
  billsView: null,
  billsInfo: null,
  beneficiaryDetails: null,
  appliViewById: null,
  reviewedComment: "",
  verifyComment: "",
  approveComment: "",
  disburseComment: "",
  rejectComment: "",
  payoutCurrentStep: 1,
  disRecordPayoutData: {
    partyId: "",
    disbDate: "",
    paymentType: "",
    pmtMode: "",
    comments: "",
    paymentTypeVal: "",
    requestAdv: 0,
    pmtReceiptDate: "",
    desc: "",
    utr: "",
    inOutWard: "",
    fundAccId: "",
    accountNumber: "",
    otpValidated: false,
    otp: "",
    refId: "",
    id: 0,
    availableBalance: 0,
    disbAmt: "",
    selectedBills: [],
    tenure: "",
    repaymentFreq: "",
  },
  loanModalSuccessStatus: false,
  loansSmartBoard: null,
  activeLoanTypeTab: "APPLICATIONS",
  loanSmartboardCollapse: true,
  openLoanDetails: false,
  currentStep: 1,
  activeLoanTab: "loanDetails",
  activeDisbursePaymentTab: "PAYOUT",
  activeStep: 1,
  loanApplicationId: 0,
  loanApproverData: {
    approvedLoanAmt: 0,
    processingFee: 0,
    interestRate: 0,
    tenure: "",
    repaymentFreq: "",
    bankNbfcPartner: "",
  },
  closeLoanFormData: {
    disbDate: "",
    disbAmt: "",
    repaymentAmount: "",
    interestRate: "",
    repaymentFreq: "",
    dueDate: "",
    fees: "",
    tax: "",
    utr: "",
    principalAmt: 0,
    totalRepayment: 0,
    currentOutstanding: 0,
    lastPaymentAmt: 0,
    lastRepaymentDate: "",
    totalReceivedAmt: 0,
    closerDate: "",
    comment: "",
    tenure: "",
    excessPaid: 0,
    actHolder: "",
    actNum: "",
    ifsc: "",
    bank: "",
    paidAmt: 0,
    interestPaid: 0,
  },
  refreshAppDetails: false,
  rmDetailsArray: [],
  getRmDeatilsStatus: false,
  allLoanApplicationsData: null,
  billsArray: [],
  disbursementModalOpen: false,
  loanPartnerDetails: null,
  loanClickAppInfo: null,
  loanTradeAppInfo: null,
  loanProductName: "",
  loanFilters: savedFilters || {
    borrowers: [],
    markets: [],
    rms: [],
    status: [],
    filterMode: "",
    firstTimeApplied: "",
    loanType: [],
  },
  loansTabFilters: savedLoanTabFilters || {
    borrowers: [],
    rms: [],
    status: [],
    filterMode: "",
    loanType: [],
    pendingPmt: [],
    finPartnerId: []
  },
  openLoansFilter: false,
  openLoansTabFilters: false,
  recordDisbursalData: null,
  allBorrowersData: [],
  openLoanTabDeatilsPanel: false,
  loanWorkingCapitalInfo: null,
  loandId: "",
  openCloseLoanPanel: false,
  allLoansData: [],
  loanTabDetailsById: null,
  openRepaymentTranscView: false,
  filteredLoans: [],
  refreshLoansAppl: false,
  filteredLoanApplications: [],
  dateRange: {
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  repayHistoryId: 0,
  repayHistoryData: null,
  loanByIdRefresh: false,
  laonDateRange: {
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  revalidateRemarks: "",
  pmtStatus: "",
  errorLoan: "",
  errorLoanAppli: "",
  isEditLoanPmt: false,
  loanPmtEdit: {
    pmtDate: "",
    amountPaid: 0,
    receiptDate: "",
    utr: "",
    waiveOff: 0,
    comments: "",
    pmtDocument: [],
    excessAmt: 0,
  },
  isCancelLoanPmt: false,
  rejectComments: "",
  pmtRows: [
    {
      amount: "",
      principalAmt: "",
      interestAmt: "",
      pmtId: 0,
      emiId: 0,
      lateFee: 0,
      penalties: 0,
      waive: 0,
      cfInterest: 0,
      excessAmt: 0,
    },
  ],
  loanUseEffectStop: false,
  applicationSearchTxt: "",
  loanMetrics: null,
  isRecordPmt: false,
  recordPayment: {
    pmtDate: "",
    amountPaid: "",
    pmtMode: "",
    comments: "",
    images: [],
  },
  financePartnersData: [],
  lastPaymentStatus: "",
  lastPaymentId: 0,
  tenureDays: [],
  openRejectModal: false,
  partnerFinManagerdisbModalOpen: false,
  partnerApprovalData: {
    approvalAmout: "",
    comments: "",
    commentsError: false,
  },
  partnerRecordPmt: {
    disbDate: "",
    disbAmt: "",
    disbBy: "",
    email: "",
    contactNum: "",
    utr: "",
    pmtMode: "",
    comments: "",
    disbImage: [],
  },
  cashId: 0,
  allPartners: []
};
const tradeSlice = createSlice({
  name: "loans",
  initialState: initialState,
  reducers: {
    updateApplicationDetails: (
      state,
      action: PayloadAction<{
        applicationViewDetails: TApplicationViewDetails | null;
      }>,
    ) => {
      state.applicationViewDetails = action.payload.applicationViewDetails;
    },
    setPdfSettings: (state, action: PayloadAction<TPdfSettings[]>) => {
      state.pdfSettings = action.payload;
    },

    updateBillsView: (
      state,
      action: PayloadAction<{
        billsView: TBillView | null;
      }>,
    ) => {
      state.billsView = action.payload.billsView;
    },

    updateBillsInfo: (
      state,
      action: PayloadAction<{
        billsInfo: TBillsInfo | null;
      }>,
    ) => {
      state.billsInfo = action.payload.billsInfo;
    },

    updateBeneficiaryDetai: (
      state,
      action: PayloadAction<{
        beneficiaryDetails: TBeneficiaryDetails | null;
      }>,
    ) => {
      state.beneficiaryDetails = action.payload.beneficiaryDetails;
    },

    updateAppliViewById: (
      state,
      action: PayloadAction<{
        appliViewById: TApplicationViewDetails | null;
      }>,
    ) => {
      state.appliViewById = action.payload.appliViewById;
    },
    setReviewComment: (state, action: PayloadAction<string>) => {
      state.reviewedComment = action.payload;
    },
    setVerifyComment: (state, action: PayloadAction<string>) => {
      state.verifyComment = action.payload;
    },
    setApproveComment: (state, action: PayloadAction<string>) => {
      state.approveComment = action.payload;
    },
    setDisburseComment: (state, action: PayloadAction<string>) => {
      state.disburseComment = action.payload;
    },
    setRejectComment: (state, action: PayloadAction<string>) => {
      state.rejectComment = action.payload;
    },
    setRevalidateRemarks: (state, action: PayloadAction<string>) => {
      state.revalidateRemarks = action.payload;
    },
    clearComments: (state) => {
      state.reviewedComment = "";
      state.verifyComment = "";
      state.approveComment = "";
      state.disburseComment = "";
      state.rejectComment = "";
    },
    setDisRecordPayoutData: (
      state,
      action: PayloadAction<{
        tenure: number;
        repaymentFreq: string;
        disbAmt: number;
      }>,
    ) => {
      state.disRecordPayoutData = {
        partyId: 0,
        disbDate: moment().format("YYYY-MM-DD"),
        pmtMode: "",
        paymentType: "",
        comments: "",
        paymentTypeVal: "",
        requestAdv: 0,
        pmtReceiptDate: "",
        desc: "",
        utr: "",
        inOutWard: "",
        accountNumber: "",
        fundAccId: "",
        otpValidated: false,
        otp: "",
        refId: "",
        id: 0,
        availableBalance: 0,
        disbAmt: action.payload.disbAmt,
        selectedBills: [],
        tenure: action.payload.tenure,
        repaymentFreq: action.payload.repaymentFreq,
      };
      state.payoutCurrentStep = 1;
    },
    updateDisRecordPayoutData: (state, action) => {
      state.disRecordPayoutData = action.payload;
    },
    updateLoanSuccess: (state, action) => {
      state.loanModalSuccessStatus = action.payload;
    },
    updateLoansSmartboard: (
      state,
      action: PayloadAction<{
        loansSmartBoard: TSmartBoard | null;
      }>,
    ) => {
      state.loansSmartBoard = action.payload.loansSmartBoard;
    },
    updateActiveLoanTypeTab: (state, action: PayloadAction<string>) => {
      state.activeLoanTypeTab = action.payload;
    },
    updateSmartboardCollapse: (state, action: PayloadAction<boolean>) => {
      state.loanSmartboardCollapse = action.payload;
    },
    setOpenLoanDetails: (state, action: PayloadAction<boolean>) => {
      state.openLoanDetails = action.payload;
    },
    setLoanCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setActiveLoanTab: (state, action: PayloadAction<string>) => {
      state.activeLoanTab = action.payload;
    },
    updateActiveDisbursePaymentTab: (state, action: PayloadAction<string>) => {
      state.activeDisbursePaymentTab = action.payload;
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    setLoanApplicationById: (
      state,
      action: PayloadAction<{
        loanApplicationById: TLoanApplicationById | null;
      }>,
    ) => {
      state.loanApplicationById = action.payload.loanApplicationById;
    },
    setLoanClickAppInfo: (
      state,
      action: PayloadAction<{
        loanClickAppInfo: TLoanClickAppInfo | null;
      }>,
    ) => {
      state.loanClickAppInfo = action.payload.loanClickAppInfo;
    },
    setLoanTradeAppInfo: (
      state,
      action: PayloadAction<{
        loanTradeAppInfo: TLoanTradeAppInfo | null;
      }>,
    ) => {
      state.loanTradeAppInfo = action.payload.loanTradeAppInfo;
    },
    setLoanWorkingCapitalInfo: (
      state,
      action: PayloadAction<{
        workingCapitalInfo: TLoanWorkingCapInfo | null;
      }>,
    ) => {
      state.loanWorkingCapitalInfo = action.payload.workingCapitalInfo;
    },
    setLoanApplicationId: (state, action: PayloadAction<number>) => {
      state.loanApplicationId = action.payload;
    },
    setRefreshLoanAppl: (state) => {
      state.refreshLoansAppl = !state.refreshLoansAppl;
    },
    setLoanApproverInfoData: (
      state,
      action: PayloadAction<TLoanApproverData>,
    ) => {
      state.loanApproverData = action.payload;
    },
    setCloseLoanFormData: (
      state,
      action: PayloadAction<TCloseLoanFormData>,
    ) => {
      state.closeLoanFormData = action.payload;
    },
    setAppDetailsRefresh: (state) => {
      state.refreshAppDetails = !state.refreshAppDetails;
    },
    updateRmDetails: (state, action: PayloadAction<RMdetails[]>) => {
      state.rmDetailsArray = action.payload;
    },
    setRefreshMarketData: (state) => {
      state.getRmDeatilsStatus = !state.getRmDeatilsStatus;
    },
    setAllApplicationsDat: (
      state,
      action: PayloadAction<TAllApplicationsObj | null>,
    ) => {
      state.allLoanApplicationsData = action.payload;
    },
    setBillsArray: (state, action: PayloadAction<TBillsInfo[]>) => {
      state.billsArray = action.payload;
    },
    setOpenDisbModal: (state, action: PayloadAction<boolean>) => {
      state.disbursementModalOpen = action.payload;
    },
    setLoanPartnerDetails: (
      state,
      action: PayloadAction<TLoanPartnerDetails | null>,
    ) => {
      state.loanPartnerDetails = action.payload;
    },
    setLoanProductName: (state, action: PayloadAction<string>) => {
      state.loanProductName = action.payload;
    },
    setLoanFilters: (state, action) => {
      state.loanFilters = action.payload;
      localStorage.setItem("loanFilters", JSON.stringify(state.loanFilters));
    },
    resetLoanFilters: (state) => {
      state.loanFilters = initialState.loanFilters;
      localStorage.removeItem("loanFilters");
    },

    setLoanTabFilters: (state, action) => {
      state.loansTabFilters = action.payload;
      localStorage.setItem(
        "loansTabFilters",
        JSON.stringify(state.loansTabFilters),
      );
    },
    resetLoanTabFilters: (state) => {
      state.loansTabFilters = initialState.loansTabFilters;
      localStorage.removeItem("loansTabFilters");
    },

    setFilteredLoans(state, action: PayloadAction<TAllLoansData[]>) {
      state.filteredLoans = action.payload;
    },
    setOpenLoansFilter: (state, action: PayloadAction<boolean>) => {
      state.openLoansFilter = action.payload;
    },

    setOpenLoanTabFilter: (state, action: PayloadAction<boolean>) => {
      state.openLoansTabFilters = action.payload;
    },
    setRecordDisbursalData: (state, action) => {
      state.recordDisbursalData = action.payload;
    },
    setAllBorrowersData: (state, action) => {
      state.allBorrowersData = action.payload;
    },
    // loans tab
    setOpenLoansTabDetals: (state, action: PayloadAction<boolean>) => {
      state.openLoanTabDeatilsPanel = action.payload;
    },
    setLoanId: (state, action: PayloadAction<string>) => {
      state.loandId = action.payload;
    },
    setOpenCloseLoanPanel: (state, action: PayloadAction<boolean>) => {
      state.openCloseLoanPanel = action.payload;
    },
    setAllLoansData: (state, action: PayloadAction<TAllLoansData[]>) => {
      state.allLoansData = action.payload;
    },
    setLoanTabDeatails: (
      state,
      action: PayloadAction<TLoanTabDetailsById | null>,
    ) => {
      state.loanTabDetailsById = action.payload;
    },
    setOpenRepaymentTranscView: (state, action: PayloadAction<boolean>) => {
      state.openRepaymentTranscView = action.payload;
    },
    setFilteredApplications: (
      state,
      action: PayloadAction<TAllApplicationsDataArray[]>,
    ) => {
      state.filteredLoanApplications = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
    setLoanDateRange: (state, action: PayloadAction<DateRange>) => {
      state.laonDateRange = action.payload;
    },
    setRepayHistoryId: (state, action: PayloadAction<number>) => {
      state.repayHistoryId = action.payload;
    },
    setRepayHistoryData: (
      state,
      action: PayloadAction<TRepayHistoryDetails | null>,
    ) => {
      state.repayHistoryData = action.payload;
    },
    clearLoanUtr: (state) => {
      if (state.repayHistoryData) {
        state.repayHistoryData.utr = "";
        state.repayHistoryData.comments = "";
      }
    },
    setLoanByIdRefresh: (state) => {
      state.loanByIdRefresh = !state.loanByIdRefresh;
    },
    setPmtStatus: (state, action: PayloadAction<string>) => {
      state.pmtStatus = action.payload;
    },
    resetRecordDisbData: (state) => {
      state.recordDisbursalData = initialState.recordDisbursalData;
    },
    setErrorLoan: (state, action: PayloadAction<string>) => {
      state.errorLoan = action.payload;
    },
    setErrorLoanAppli: (state, action: PayloadAction<string>) => {
      state.errorLoanAppli = action.payload;
    },
    setIsEditLoanPmt: (state, action: PayloadAction<boolean>) => {
      state.isEditLoanPmt = action.payload;
    },
    setAddLoanPmtEdit: (
      state,
      action: PayloadAction<{
        loanPmt: TRepayHistoryDetails;
      }>,
    ) => {
      let details = action.payload.loanPmt;
      state.loanPmtEdit.pmtDate = details?.date;
      state.loanPmtEdit.amountPaid = details?.amount;
      state.loanPmtEdit.utr = details?.utr;
      state.loanPmtEdit.receiptDate = details?.pmtReceiptDate;
      state.loanPmtEdit.waiveOff = Number(details?.waive);
      if (details?.pmtStatus === "PENDING") {
        state.loanPmtEdit.comments = details?.comments;
      } else if (details?.pmtStatus === "ACCEPTED") {
        state.loanPmtEdit.comments = details?.receiptDesc;
      } else {
        state.loanPmtEdit.comments = "";
      }
    },
    setPmtDocuments: (state, action: PayloadAction<TLoanDocument[]>) => {
      state.loanPmtEdit.pmtDocument = action.payload;
    },
    clearPmtDocuments: (state) => {
      state.loanPmtEdit.pmtDocument = [];
    },
    updateLoanPmtEdit: (
      state,
      action: PayloadAction<{
        details: TLoanPmtEdit;
      }>,
    ) => {
      state.loanPmtEdit = action.payload.details;
    },
    setiIsCancelLoanPmt: (state, action: PayloadAction<boolean>) => {
      state.isCancelLoanPmt = action.payload;
    },
    setRejectComments: (state, action: PayloadAction<string>) => {
      state.rejectComments = action.payload;
    },
    setPmtRows(state, action: PayloadAction<TLoanPmtTableEdit[]>) {
      state.pmtRows = action.payload;
    },
    setLoanUseEffectStop: (state, action: PayloadAction<boolean>) => {
      state.loanUseEffectStop = action.payload;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.applicationSearchTxt = action.payload;
    },
    setLoanMetricsObj: (
      state,
      action: PayloadAction<TLoanMetricsObj | null>,
    ) => {
      state.loanMetrics = action.payload;
    },
    setIsRecordPmt: (state, action: PayloadAction<boolean>) => {
      state.isRecordPmt = action.payload;
    },
    setRecordPayment: (state, action: PayloadAction<LoanRecordPmt>) => {
      state.recordPayment = action.payload;
    },
    clearRecordPayment: (state) => {
      state.recordPayment = null;
    },
    setFinancePartnerData: (
      state,
      action: PayloadAction<TFinancePartnersData[]>,
    ) => {
      state.financePartnersData = action.payload;
    },
    setLastPaymentStatus: (state, action: PayloadAction<string>) => {
      state.lastPaymentStatus = action.payload;
    },
    setLatPaymentId: (state, action: PayloadAction<number>) => {
      state.lastPaymentId = action.payload;
    },
    setTenureDays: (state, action: PayloadAction<string[]>) => {
      state.tenureDays = action.payload;
    },
    setOpenRejectModal: (state, action: PayloadAction<boolean>) => {
      state.openRejectModal = action.payload;
    },
    // partner mitarat
    setPartnerFinManagerdisbModalOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.partnerFinManagerdisbModalOpen = action.payload;
    },
    updatePartnerApprovalData: (
      state,
      action: PayloadAction<Partial<typeof state.partnerApprovalData>>,
    ) => {
      state.partnerApprovalData = {
        ...state.partnerApprovalData,
        ...action.payload,
      };
    },
    setPartnerRecordPmt: (state, action: PayloadAction<TPartnerRecordPmt>) => {
      state.partnerRecordPmt = action.payload;
    },
    resetPartnerRecordPmt: (state) => {
      state.partnerRecordPmt = initialState.partnerRecordPmt;
    },
    resetPartnerApprovalData: (state) => {
      state.partnerApprovalData = initialState.partnerApprovalData;
    },
    setCashId: (state, action: PayloadAction<number>) => {
      state.cashId = action.payload;
    },
    setAllPartners: (state, action: PayloadAction<AllPartners[]>) => {
      state.allPartners = action.payload;
    },
  },
});

export const {
  updateApplicationDetails,
  setPdfSettings,
  updateBillsView,
  updateBillsInfo,
  updateBeneficiaryDetai,
  updateAppliViewById,
  setReviewComment,
  setVerifyComment,
  setApproveComment,
  setDisburseComment,
  setRejectComment,
  clearComments,
  setDisRecordPayoutData,
  updateDisRecordPayoutData,
  updateLoanSuccess,
  updateLoansSmartboard,
  updateActiveLoanTypeTab,
  updateSmartboardCollapse,
  setOpenLoanDetails,
  setLoanCurrentStep,
  setActiveLoanTab,
  updateActiveDisbursePaymentTab,
  setActiveStep,
  setLoanApplicationById,
  setLoanApplicationId,
  setLoanApproverInfoData,
  setCloseLoanFormData,
  setAppDetailsRefresh,
  updateRmDetails,
  setRefreshMarketData,
  setAllApplicationsDat,
  setBillsArray,
  setOpenDisbModal,
  setLoanPartnerDetails,
  setLoanClickAppInfo,
  setLoanTradeAppInfo,
  setLoanProductName,
  setLoanFilters,
  resetLoanFilters,
  setOpenLoansFilter,
  setRecordDisbursalData,
  setAllBorrowersData,
  setOpenLoansTabDetals,
  setLoanWorkingCapitalInfo,
  setLoanId,
  setOpenCloseLoanPanel,
  setAllLoansData,
  setLoanTabDeatails,
  setOpenRepaymentTranscView,
  setLoanTabFilters,
  resetLoanTabFilters,
  setOpenLoanTabFilter,
  setFilteredLoans,
  setRefreshLoanAppl,
  setFilteredApplications,
  setDateRange,
  setRepayHistoryId,
  setRepayHistoryData,
  setLoanByIdRefresh,
  setLoanDateRange,
  clearLoanUtr,
  setRevalidateRemarks,
  setPmtStatus,
  resetRecordDisbData,
  setErrorLoan,
  setErrorLoanAppli,
  setIsEditLoanPmt,
  setAddLoanPmtEdit,
  setPmtDocuments,
  updateLoanPmtEdit,
  setiIsCancelLoanPmt,
  setRejectComments,
  setPmtRows,
  clearPmtDocuments,
  setLoanUseEffectStop,
  setSearchText,
  setLoanMetricsObj,
  setIsRecordPmt,
  setRecordPayment,
  clearRecordPayment,
  setFinancePartnerData,
  setLastPaymentStatus,
  setLatPaymentId,
  setTenureDays,
  setOpenRejectModal,
  setPartnerFinManagerdisbModalOpen,
  updatePartnerApprovalData,
  setPartnerRecordPmt,
  resetPartnerRecordPmt,
  resetPartnerApprovalData,
  setCashId,
  setAllPartners
} = tradeSlice.actions;
export default tradeSlice.reducer;
